import {U, COMPARSION, WISHLIST, TOOLTIP} from './global';
import {GTM} from "./gtm";

export const PROMO = {
    id: 0,
    context_id: 0,
    brand_id: 0,
    page: 1,
    sort: 'internal',
    direction: 'desc',
    q: '',
    data: '',
    searchtimeout: false,
    searchtimeouttime: 1000,
    previousState: '',
    process: false,

    clean_params: function() {
        let was_params = {
            context_id: $(".blog-categories.contexts").length ? $(".blog-categories.contexts a.active").data('context') : 0,
            brand_id: $(".blog-categories.brands").length ? $(".blog-categories.brands a.active").data('brand') : 0,
            q: $(".promo__search [type=text]").val(),
            page: this.page,
            sort: this.sort,
            direction: this.direction,
        };

        let regex = /[?&]([^&#]*)/g,
            url = this.current_url(),
            params = {},
            sorting = false,
            match;

        while(match = regex.exec(url)) {
            let param = match[1].split('=');

            if (param[0].substr(0, 4)=='sort') {
                // sorting
                sorting = param[0].split('-');

                if (!(typeof sorting[1] === "undefined") && !(typeof sorting[2] === "undefined")) {
                    if (!(was_params.sort==sorting[1]) || !(was_params.direction==sorting[2])) {
                        this.sort = sorting[1];
                        this.direction = sorting[2];
                    }
                }
            } else {
                params[param[0]] = param[1];
            }
        }

        if (!sorting) {
            this.sort = 'internal';
            this.direction = 'desc';
        }

        if ($(".catalog__goods .sorting-toggle").length) {
            $(".catalog__goods .sorting-toggle a").removeClass('active');

            if (this.sort=='internal') {
                $(".catalog__goods .sorting-toggle a[data-sort=internal]").addClass('active');
            } else {
                $(".catalog__goods .sorting-toggle a[data-sort=" + this.sort + "][data-direction=" + this.direction + "]").addClass('active');
            }
        }

        $(".blog-categories.contexts a").removeClass('active');
        $(".blog-categories.brands a").removeClass('active');
        $(".promo__search [type=text]").val('');

        if (Object.keys(params).length > 0)
            $.each(params, (key, value) => {
                switch(key) {
                    case 'context_id':
                        $(".blog-categories.contexts a[data-context=" + value + "]").addClass('active');
                        break;
                    case 'brand_id':
                        $(".blog-categories.brands a[data-brand=" + value + "]").addClass('active');
                        break;
                    case 'page':
                        this.page = value;
                        break;
                    case 'q':
                        $(".promo__page .promo__search [type=text]").val(decodeURI(value));
                        break;
                    default:
                        break;
                }
            });

        if (!$(".blog-categories.contexts a.active").length)
            $(".blog-categories.contexts a[data-context=0]").addClass('active');

        if (!$(".blog-categories.brands a.active").length)
            $(".blog-categories.brands a[data-brand=0]").addClass('active');

    },

    load_goods: function(history_nav) {

        let params = {};

        clearTimeout(this.searchtimeout);

        if ($(".blog-categories.contexts a.active").length)
            this.context_id = $(".blog-categories.contexts a.active").data('context');

        if ($(".blog-categories.brands a.active").length)
            this.brand_id = $(".blog-categories.brands a.active").data('brand');

        if (this.context_id > 0)
            params.context_id = this.context_id;

        if (this.brand_id > 0)
            params.brand_id = this.brand_id;

        $('.pagination').remove();

        params.page = this.page;
        this.q = $.trim($(".promo__search [type=text]").val());

        if (this.q)
            params.q = this.q;

        let sortstr = this.sort=='internal' ? '' : 'sort='+this.sort+'-'+ this.direction + '&';
        let url = document.location.pathname + '?' + sortstr + $.param(params);

        // if (!history_nav)
        //     history.pushState({}, null, url);

        GTM.event('pageview', url);
        this.previousState = this.current_url();

        $.post(
            '/aj',
            {
                action: 'promo',
                to: 'index',
                id: this.id,
                context_id: this.context_id,
                brand_id: this.brand_id,
                page: this.page,
                sort: this.sort,
                direction: this.direction,
                q: this.q
            },
            (data) => {

                if (!(this.q=='') && data.html=='')
                    $(".promo__search").addClass('error');
                else {
                    $(".promo__search").removeClass('error');

                    if (this.page > 1 && !history_nav)
                        $(".promo__page .looplist").append(data.html);
                    else
                        $(".promo__page .looplist").html(data.html);
                }

                $(".catalog__goods").append(data.pagination);

                COMPARSION.update_anchors();
                WISHLIST.update_anchors();

                if (!data.more)
                    $('.promo__page .show-more').addClass('hidden');
                else
                    $('.promo__page .show-more').removeClass('hidden');
            },
            'json'
        );
    },

    current_url: function(){
        let url = window.location.href.split(location.hostname);
        return typeof url[1] === "string" ? url[1] : "";
    },

    search_timeout: function() {
        clearTimeout(this.searchtimeout);
        this.searchtimeout = setTimeout(() => {
            this.load_goods();
        }, this.searchtimeouttime);
    },

    load_branding_bg: function() {
        if ($(".promo__branding").length)
            if (U.isMobile())
                $("body").append('<style>.promo__branding{background-image: url(\'' + $(".promo__branding").data('bg-mobile') + '\')}</style>');
            else
                $("body").append('<style>.promo__branding{background-image: url(\'' + $(".promo__branding").data('bg') + '\')}</style>');
    },

    start_countdown: function() {
        if ($(".promo__countdown").length) {
            $.each($(".promo__countdown"), function(index, container){
                container = $(container);
                let template = container.html();
                container.countdown(container.data('time'), function(event) {
                    let $this = $(this).html(event.strftime(template));
                });
            });
        }
    }

};

export function init_PROMO_events() {
    jQuery(document).ready(function () {

        PROMO.load_branding_bg();

        // daypromo contexts
        $(".promo__main .blog-categories a").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);
            let on = btn.hasClass('active') ? false : true;

            btn.parent().find('a').removeClass('active');
            btn.addClass('active');

            if (PROMO.data == '')
                PROMO.data = $(".promo__biglist").html();

            if (on) {
                $(".promo__biglist").empty().html(PROMO.data);

                if (!(btn.data('context') == 0))
                    $(`.promo__biglist >div:not([data-context*='|${btn.data('context')}|'])`).remove();
            } else {
                $(".promo__biglist").empty().html(PROMO.data);
            }

            U.send_impressions();
        });

        jQuery("body").on("click", ".promo__page:not(.filter-mode):not(.promo__page-filter) .show-more:not(.link)", function (e) {
            e.preventDefault();
            e.stopPropagation();
            PROMO.page++;
            PROMO.load_goods();
        });

        // сортировка в декстопе
        jQuery("body").on('click', ".sorting-toggle", function (e) {
            e.preventDefault();
            let btn = $(this);
            btn.toggleClass('active');
        });

        jQuery("body").on("click", ".js-sorting__item-promo", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let btn = $(this);

            $(".sorting__item-active").removeClass('sorting__item-active');
            $(".js-sorting__item-promo[data-sort=" + btn.data('sort') + "][data-direction=" + btn.data('direction') + "]").addClass('sorting__item-active');
            $(".sorting__selected").html(btn.text());
            TOOLTIP.hide();

            PROMO.sort = btn.data('sort');
            PROMO.direction = btn.data('direction');
            PROMO.page = 1;

            PROMO.load_goods();
        });

        jQuery("body").on("click", ".promo__page .blog-categories.contexts a", function (e) {
            e.preventDefault();
            let btn = $(this);
            $(".blog-categories.contexts a").removeClass('active');
            btn.addClass('active');

            if ($(".promo__search").length)
                $(".promo__search").removeClass('error').find('[type=text]').val('');

            PROMO.q = '';
            PROMO.page = 1;
            PROMO.load_goods();
        });

        jQuery("body").on("click", ".promo__page .blog-categories.brands a", function (e) {
            e.preventDefault();
            let btn = $(this);
            $(".blog-categories.brands a").removeClass('active');
            btn.addClass('active');

            if ($(".promo__search").length)
                $(".promo__search").removeClass('error').find('[type=text]').val('');

            PROMO.q = '';
            PROMO.page = 1;
            PROMO.load_goods();
        });

        jQuery("body").on("keydown", ".promo__search [type=text]", function (e) {
            if (e.keyCode == 8)
                $(this).trigger('keyup');
        });

        jQuery("body").on("keyup", ".promo__search [type=text]", function (e) {
            $(".promo__search").removeClass('error');

            if ($.trim($(this).val()) == '')
                $(".promo__search .remove").addClass('hidden');
            else
                $(".promo__search .remove").removeClass('hidden');

            if (e.keyCode == 13) {
                e.stopPropagation();
                e.preventDefault();
                PROMO.q = $.trim($(this).val());
                PROMO.load_goods();
            } else {
                PROMO.q = $.trim($(this).val());
                PROMO.search_timeout();
            }
        });

        jQuery("body").on("submit", ".promo__search", function (e) {
            e.preventDefault();
            PROMO.load_goods();
        });

        jQuery("body").on("focusin", ".promo__search [type=text]", function (e) {
            $(".promo__search .remove").addClass('arrow arrows');
        });

        jQuery("body").on("focusout", ".promo__search [type=text]", function (e) {
            $(".promo__search .remove").removeClass('arrow');
        });

        jQuery("body").on("click", ".promo__search .remove", function (e) {
            e.preventDefault();
            let btn = $(this);

            if (btn.hasClass('arrows')) {
                btn.removeClass('arrows');
                $(".promo__page .promo__search [type=text]").trigger('focusout');
            } else {
                btn.addClass('hidden');
                $(".promo__search input").val('');
                PROMO.q = '';
            }
            PROMO.load_goods();
        });

        if (!(typeof G.promo_id === "undefined")) {
            PROMO.id = G.promo_id;
            PROMO.start_countdown();
        }

        if (U.isMobile() && $(".promo__page .blog-categories").length)
            $.each($(".promo__page .blog-categories"), function (i, container) {
                container = $(container);
                if (container.find('>a').length) {

                    let links = container.children('a').not('[data-context=0]').not('[data-brand=0]');
                    let sortList = Array.prototype.sort.bind(links);
                    sortList(function (a, b) {

                        let aText = a.innerHTML;
                        let bText = b.innerHTML;

                        if (aText == bText)
                            return 0;
                        else
                            return aText < bText ? -1 : 1;
                    });

                    container.append(links);

                }
            });

        PROMO.previousState = PROMO.current_url();

        // if (!U.isMobile() && $("section.promo__page").length)
        //     setTimeout(function () {
        //         $(window).on('popstate', function (e) {
        //             if (!(PROMO.previousState == PROMO.current_url())) {
        //                 PROMO.clean_params();
        //                 PROMO.load_goods(true);
        //             } else
        //                 return true;
        //         });
        //     }, 0);

    });
}

init_PROMO_events();